import type { GetMatchQuery } from '../../../../types/graphql-generated';
import { GoalIcon, PenaltyGoalIcon, OwnGoalIcon, SubInIcon, SubOutIcon, RefereeCard } from '../../../components/ui/events';

type Event = NonNullable<GetMatchQuery['getMatch']>['events'][number];

interface EventTeam {
  shortName?: string | null;
  shield?: string | null;
  shieldPng?: string | null;
}

interface MatchEventRowProps {
  event: Event;
  /** The team the player belonged to in this match (from its match-player row). */
  team?: EventTeam | null;
}

export const MatchEventRow: React.FC<MatchEventRowProps> = ({ event, team }) => {
  const shield = team?.shield || team?.shieldPng;
  const renderIcon = () => {
    switch (event.eventType) {
      case 'in':
        return <SubInIcon />;
      case 'out':
        return <SubOutIcon />;
      case 'goal':
        return <GoalIcon />;
      case 'penalty_goal':
        return (
          <>
            <PenaltyGoalIcon /> <span>P</span>
          </>
        );
      case 'own_goal':
        return (
          <>
            <OwnGoalIcon /> <span>PP</span>
          </>
        );
      case 'yellow':
        return <RefereeCard color="yellow" />;
      case 'red':
        return <RefereeCard color="red" />;
      default:
        return null;
    }
  };

  return (
    <div className="flex items-center gap-3 border-b border-[#eef1f6] py-2.5 last:border-b-0">
      <span className="w-8 shrink-0 text-right font-heading text-[13px] font-extrabold text-slate-500">
        {event.minute}'
      </span>
      <span className="flex items-center gap-1">{renderIcon()}</span>
      <span className="min-w-0 flex-1 truncate text-[14px] font-medium text-[#2a3242]">
        {event.player.nick}
      </span>
      {shield ? (
        <img
          src={shield}
          alt={team?.shortName ?? 'Equipo'}
          className="h-[18px] w-[18px] shrink-0 object-contain"
        />
      ) : team?.shortName ? (
        <span className="shrink-0 rounded-md bg-[#eef1f6] px-1.5 py-0.5 text-[10px] font-bold uppercase text-slate-500">
          {team.shortName}
        </span>
      ) : null}
    </div>
  );
};
